import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { RealtimeProvider } from './context/RealtimeContext';
import { ViewProvider } from './context/ViewContext';
import { WorkspaceProvider } from './context/WorkspaceContext';
import { ToastProvider } from './context/ToastContext';
import { ReportWorkspaceProvider } from './context/ReportWorkspaceContext';
import { MatchWorkspaceProvider } from './context/MatchWorkspaceContext';
import { MatchRuntimeProvider } from './context/MatchRuntimeContext';
import { CalendarRuntimeProvider } from './context/CalendarRuntimeContext';
import { SeasonRuntimeProvider } from './context/SeasonRuntimeContext';
import { LeagueRuntimeProvider } from './context/LeagueRuntimeContext';
import { DirtyNavigationProvider } from './context/DirtyNavigationProvider';
import UmamiPageTracker from './components/UmamiPageTracker';
import AppRoutes from './AppRoutes';


const queryClient = new QueryClient();
const router = createBrowserRouter([{
  path: '*',
  element: <DirtyNavigationProvider><MatchRuntimeProvider><CalendarRuntimeProvider><SeasonRuntimeProvider><LeagueRuntimeProvider><UmamiPageTracker /><AppRoutes /></LeagueRuntimeProvider></SeasonRuntimeProvider></CalendarRuntimeProvider></MatchRuntimeProvider></DirtyNavigationProvider>,
}]);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <WorkspaceProvider>
            <ReportWorkspaceProvider>
              <MatchWorkspaceProvider>
            <ViewProvider>
            <RealtimeProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
            </RealtimeProvider>
            </ViewProvider>
              </MatchWorkspaceProvider>
            </ReportWorkspaceProvider>
          </WorkspaceProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
